import { ReactSortable } from "react-sortablejs";
import { useState, useRef, useContext } from 'react';
import { getImages } from '../const';
import { ChatContext } from "../Context/ChatContext";

const PhotosUpload = ({ close, setPhotoSIDs, activeChatData }) => {
    const [imgsSrc, setImgsSrc] = useState([]);

    const {uploadDocument, removeBackground} = useContext(ChatContext);

    const [imageProcessing,setImageProccessing] = useState(false);

    const readFileContents = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                resolve({fileData:file,item:reader.result});
            };
            reader.onerror = reject;
        });
    };

    const readAllFiles = async (files) => {
        return Promise.all(files.map(file => readFileContents(file)));
    };

    let lastIndexUsed = 0;
    const handleUpload = async (e) => {
        const files = Array.from(e.target.files);
        try {
            setImageProccessing(true);

            const urls = await readAllFiles(files);

            const newImgs = urls.map((item) => {
                let index = lastIndexUsed;
                let id = "item" + index;

                while (imgsSrc.some(img => img.id === id)) {
                    index++;
                    id = "item" + index;
                }

                lastIndexUsed++;

                return {
                    ...item,
                    id: id,
                    key: id,
                    selected: false,
                    backgroungRemoved: false
                };
            });

            setImgsSrc([...imgsSrc, ...newImgs]);

            setImageProccessing(false);
            

        } catch (error) {
            // alert("Error uploading files");
            setImageProccessing(false);
        }
    };

    const removeBackgroundImages = async (e) => {

        setImageProccessing(true);

        let newImgs = await Promise.all(imgsSrc.map(item => doRemoveBackground(item)));

        console.log(newImgs);

        setImgsSrc(newImgs);

        setImageProccessing(false);


    }

    const getFileFromBase64 = (string64, fileName) => {

        //const blob = new Blob([data.file], { type: item.fileData.type });
        /*const newFile = new File([data.file], item.fileData.name, {
            type: item.fileData.type,
            lastModified: Date.now()
        });*/

        // extract content type and base64 payload from original string
        var pos = string64.indexOf(';base64,');
        var type = string64.substring(5, pos);
        var b64 = string64.substr(pos + 8);

        // decode base64
        var imageContent = atob(b64);

        // create an ArrayBuffer and a view (as unsigned 8-bit)
        var buffer = new ArrayBuffer(imageContent.length);
        var view = new Uint8Array(buffer);

        // fill the view, using the decoded base64
        for(var n = 0; n < imageContent.length; n++) {
            view[n] = imageContent.charCodeAt(n);
        }

        // convert ArrayBuffer to Blob
        var blob = new Blob([buffer], { type: type });

        return new File([blob], fileName, { lastModified: new Date().getTime(), type });
      }

    const doRemoveBackground = async (item) => {
        return new Promise((resolve, reject) => {

            if(item.selected && !item.backgroundRemoved) {

                const formData = new FormData();
                formData.append('file', item.fileData);
                formData.append('chat_service_sid',activeChatData && activeChatData.chat_service_sid);
                //formData.append('base_url',true);
        
                const upload = removeBackground(formData);
                upload.then((data) => {

                    if(data.file) {

                        const newFile = getFileFromBase64(data.file, item.fileData.name);

                        console.log(item.fileData,newFile,data.file);

                        resolve({...item, item:data.file, fileData:newFile, backgroundRemoved:true});
                    } else 
                        reject();
                });
            } else {
                resolve(item);
            }
        });
    };

    const uploadFile = async (item) => {
        return new Promise((resolve, reject) => {

            const formData = new FormData();
            formData.append('file', item.fileData);
            formData.append('chat_service_sid',activeChatData && activeChatData.chat_service_sid);
            //formData.append('base_url',true);
    
            const upload = uploadDocument(formData);
            upload.then((data) => {

                if (data.twilio_data.sid) {

                    setPhotoSIDs(photoSIDs => [...photoSIDs,data.twilio_data.sid]);

                    resolve();
                } else {
                    reject();
                }
            });
        });
    };

    const selectImage = (e) => {
        let newImgs = imgsSrc.map(item => item.id == e.target.id ? {...item, selected: !item.selected} : item);

        setImgsSrc(newImgs);
    };

    const isSortingRef = useRef(false);

    const updateOrder = (updatedList) => {
        if (!isSortingRef.current) return;
        isSortingRef.current = false;
        setImgsSrc(updatedList);
    };

    const isMounted = useRef(false);
    
    const deleteItem = () => {
        const filteredImgsSrc = imgsSrc.filter(item => !item.selected);
        setImgsSrc(filteredImgsSrc);
    };

    const setAsPrimary = () => {
        const primaryImgs = imgsSrc.filter(item => item.selected);
        const remainingImgs = imgsSrc.filter(item => !item.selected);
        setImgsSrc([...primaryImgs, ...remainingImgs]);
    };

    const finishFormHandler = async () => {

        console.log(imgsSrc);

        setImageProccessing(true);

        let uploadResults = await Promise.all(imgsSrc.map(item => uploadFile(item))); 

        setImageProccessing(false);           

        close();
    };

    return (
        
        <div className="modal-content p-0">
            <div className='d-none d-lg-block'>
                <div className="modal-header p-3 chat-modal-header">
                    <h1 className="modal-title filter-modal-title text-center w-100 fw-500">
                        Add Photos
                    </h1>
                    <button className="sm-box-close mt-0" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
            </div>
            <div className="modal-body py-4">
                <div className="d-flex align-items-end justify-content-between mb-3">
                    <div className="pe-5">
                        <div className="sm-title fw-600 text-uppercase mb-4">Did you know you can replace the background?</div>
                        <div className="xs-title font-14"><span className="text-red">TIP: </span>  &nbsp;Select the photos you want to replace the background. For best results please use exterior photos with contrasting backrounds and no reflections, glare or items covering the vehicle. Go ahead try it now!</div>
                    </div>
                    <div className="pb-1">
                        {!imageProcessing && <button type="button" className="red-transparent-btn text-uppercase w-240 py-2 upload-photo-btn" onClick={removeBackgroundImages}> 
                            {/*<input type="file" onChange={(e) => {handleUpload(e,true)}} name="file" accept="image/*" multiple />*/}
                            <img className="me-2" src={getImages('photo-file-icon.png')}/> Replace Background
                        </button>}
                    </div>
                </div>
                <div className="upload-photo-box">
                    <div className='up-img-flex'>
                        <div className="d-flex align-items-center upload-action-block mb-4">
                        </div>
                        {!imgsSrc.length > 0 ? 
                            <div className="form-box">
                                {/* <div className="xs-title fw-500">Select up to 20 photos you wish to upload</div> */}
                                <div className="text-center">
                                    <button className="w-100 py-2 upload-photo-btn browse-photo-btn ptb-100">
                                        <input type="file" onChange={handleUpload} name="file" accept="image/*" multiple />
                                        <div className="mb-3 text-center xs-title text-uppercase ">Browse Photos</div>
                                        <div className="mt-4 text-center tip-text">Maximum file size 5mb, file format
                                            allowed jpg, png, gif</div>
                                    </button>
                                </div>
                            </div>
                            : 
                            <div className='grid-overflow'>
                                <ReactSortable
                                    ghostclassName="dropArea"
                                    handle=".dragHandle"
                                    filter=".ignoreDrag"
                                    preventOnFilter={true}
                                    className="grid-container"
                                    dragoverBubble={false}
                                    list={imgsSrc}
                                    onUpdate={() => isSortingRef.current = true}
                                    setList={(updatedList) => updateOrder(updatedList)}
                                >
                                    {imgsSrc.map((item, index) => (
                                        <div className="gc-col" key={index}>
                                            <div className={(item.primary) ? "pl-box checked dragHandle mt-3" : "pl-box dragHandle mt-3"} key={index}>
                                                <div style={{ padding: "12px" }}>
                                                    <div className="pl-img">
                                                        <img src={item.item} />
                                                    </div>
                                                    <div className="custom-checkbox sm-checkbox mt-2">
                                                        <input className="styled-checkbox" id={item.id} type="checkbox"
                                                            checked={item.selected}
                                                            value={item.id} onClick={(e) => selectImage(e)} onChange={(e) => console.log(e.target.value)} />
                                                        <label htmlFor={item.id}><span>{item.selected ? "Selected" : "Select"}</span></label>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </ReactSortable>
                            </div>
                        }
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-5">
                    <div>
                        {/* <button type='button' className="action-link" onClick={setAsPrimary}>
                            <img src={getImages('icon-primary.png')} alt="Set as Primary" /> Set as Primary
                        </button> */}
                        <button type='button' className="action-link me-5" onClick={deleteItem}>
                            <img className="me-2" src={getImages('icon-delete-photo.png')} alt="Delete" /> Delete
                        </button>
                        <button type='button' className="action-link upload-photo-btn">
                            <input type="file" onChange={handleUpload} accept="image/*" multiple />
                            <img className="me-2" src={getImages('icon-photos-small.png')} alt="Add More Photos" /> Add More Photos
                        </button>
                    </div>
                    <div>
                        {!imageProcessing && <button className="red-btn w-190 text-uppercase" onClick={finishFormHandler}>Upload Photos</button>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhotosUpload;
